import { useContext, useEffect, useState } from 'react';

import { CustomerContext } from 'contexts/CustomerContext';
import { getPromoCodeRedemptions } from 'services/customer';
import { promoCodeRedemptionType } from 'types';

/**
 * Promo codes the customer redeemed, most recent first.
 *
 * For a customer whose access came from a promo code this is the only record of it: there is no
 * order, payment or transaction to hang the information off.
 */
export function usePromoCodeRedemptions(): {
  redemptions: Array<promoCodeRedemptionType>;
  isLoaded: boolean;
} {
  const [redemptions, setRedemptions] = useState<
    Array<promoCodeRedemptionType>
  >([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const { customerId, customerType } = useContext(CustomerContext);

  useEffect(() => {
    if (!customerId || !customerType) {
      return;
    }

    (async () => {
      const result = await getPromoCodeRedemptions(customerId, customerType);

      if (result?.data) {
        setRedemptions(result.data);
      }
      setIsLoaded(true);
    })();
  }, [customerId, customerType]);

  return { redemptions, isLoaded };
}
